import { getRequest, postRequest } from 'utils/httpServices';

class transactionsAPI {
  static transactions = (queryData = {}, config = {}) => {
    return postRequest(`v2/dashboard/transaction/list`, queryData, config).catch((error) => ({
      success: false,
      data: (error.response && error.response.data) || {},
      status: (error.response && error.response.status) || 400
    }));
  };

  static transaction_summary = (queryData = {}, config = {}) => {
    return getRequest(`v2/dashboard/transaction/transaction-summary`, queryData, config).catch(
      (error) => ({
        success: false,
        data: (error.response && error.response.data) || {},
        status: (error.response && error.response.status) || 400
      })
    );
  };
}

export default transactionsAPI;
